"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Ads API
 * The Spotify Ads API.
 *
 * The version of the OpenAPI document: 3.0.0
 * Contact: selfserve-infra-api@spotify.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.CreateFullCampaignResponseToJSON = exports.CreateFullCampaignResponseFromJSONTyped = exports.CreateFullCampaignResponseFromJSON = exports.instanceOfCreateFullCampaignResponse = void 0;
var runtime_1 = require("../runtime");
var CampaignResponse_1 = require("./CampaignResponse");
var CreateFullAdsetResponse_1 = require("./CreateFullAdsetResponse");
/**
 * Check if a given object implements the CreateFullCampaignResponse interface.
 */
function instanceOfCreateFullCampaignResponse(value) {
    var isInstance = true;
    return isInstance;
}
exports.instanceOfCreateFullCampaignResponse = instanceOfCreateFullCampaignResponse;
function CreateFullCampaignResponseFromJSON(json) {
    return CreateFullCampaignResponseFromJSONTyped(json, false);
}
exports.CreateFullCampaignResponseFromJSON = CreateFullCampaignResponseFromJSON;
function CreateFullCampaignResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'campaign': !(0, runtime_1.exists)(json, 'campaign') ? undefined : (0, CampaignResponse_1.CampaignResponseFromJSON)(json['campaign']),
        'adSets': !(0, runtime_1.exists)(json, 'ad_sets') ? undefined : (json['ad_sets'].map(CreateFullAdsetResponse_1.CreateFullAdsetResponseFromJSON)),
    };
}
exports.CreateFullCampaignResponseFromJSONTyped = CreateFullCampaignResponseFromJSONTyped;
function CreateFullCampaignResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'campaign': (0, CampaignResponse_1.CampaignResponseToJSON)(value.campaign),
        'ad_sets': value.adSets === undefined ? undefined : (value.adSets.map(CreateFullAdsetResponse_1.CreateFullAdsetResponseToJSON)),
    };
}
exports.CreateFullCampaignResponseToJSON = CreateFullCampaignResponseToJSON;
